import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import '../Package/Package.css';
import PackageInclude from '../Package/PackageInclude';
import PackageExclude from '../Package/PackageExclude';
import PackageTermsandCondition from '../Package/PackageTermsandCondition';
import HajjTabs from "../AllTabs/HajjTabs";
import HajjPackageForm from "./HajjPackageForm";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Header from "../../Common/Layout/Header";
import {
  RiListCheck,
  RiPlaneLine,
  RiHotelBedLine,
  RiCameraLensLine,
  RiCarLine,
  RiMapPinLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine,
  RiFileShieldLine,
  RiEyeLine,
  RiLayoutLine,
  RiGroupLine 
} from "react-icons/ri";
import PackageTemplates from "../Package/PackageTemplates";
import PackageManageApplicants from "../Package/PackageManageApplicants";
import PackageItinerary from "../Package/PackageItinerary";
import PackageDetailsView from "../Package/PackageDetailsView";
// Import missing components for new tabs
import PackageFlightBooking from "../Package/PacakgeFlightBooking";
import PackageHotelBooking from "../Package/PackageHotelBooking";
import PackageSightSeeing from "../Package/PackageSightSeeing";
import PackageTransfer from "../Package/PackageTransfer";


const Hajj = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { packageId } = useParams();
  const location = useLocation();
  const [isCreated, setIsCreated] = useState(!!packageId);
  const [isEditMode, setIsEditMode] = useState(!!packageId);
  const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
  const [packageDetails, setPackageDetails] = useState(null);
  
  useEffect(() => {
    if (packageId) {
      setIsCreated(true);
      setIsEditMode(true);
      if (location.state?.activeTab !== undefined) {
        setActiveTab(location.state.activeTab);
      }
    } else {
      setIsCreated(false);
      setIsEditMode(false);
      setActiveTab(0);
      setPackageDetails(null);
    }
  }, [packageId, location.state]);

  useEffect(() => {
    const getPackageDetails = async () => {
      if (packageId) {
        try {
          const response = await apiService.get(`${config.GETPACKAGEBYID}/${packageId}`);
          setPackageDetails(response.data || response);
        } catch (error) {
          console.error("Failed to fetch package details:", error);
          navigate("/hajj");
        }
      }
    };
    getPackageDetails();
  }, [packageId, navigate]);

  const handleTabSelect = (index) => {
    setActiveTab(index);
  };
  
  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);
  
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <HajjTabs pageName="HAJJPACKAGE" />
              </div>
              <Tabs
                selectedIndex={activeTab}
                onSelect={handleTabSelect}
                className="package-tabs-container"
              >
                <div className="package-tabs-nav">
                  <TabList className="list-unstyled">
                    <Tab className={`package-tab-item ${activeTab === 0 ? "active" : ""}`}>
                      <RiListCheck />
                      Hajj Form
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 1 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiMapPinLine />
                      <span>Itineraries</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 2 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiPlaneLine />
                      <span>Flight</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 3 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiHotelBedLine />
                      <span>Hotel</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 4 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiCameraLensLine />
                      <span>Ziyarat</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 5 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiCarLine />
                      <span>Transfer</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 6 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiCheckboxCircleLine />
                      Includes
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 7 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiCloseCircleLine />
                      Excludes
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 8 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiFileShieldLine />
                      Terms & Conditions
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 9 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiEyeLine />
                      <span>View Details</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 10 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiLayoutLine />
                      <span>Templates</span>
                    </Tab>
                    <Tab className={`package-tab-item ${activeTab === 11 ? "active" : ""} ${!isCreated ? "disabled" : ""}`} disabled={!isCreated}>
                      <RiGroupLine />
                      <span>Manage Applicants</span>
                    </Tab>
                  </TabList>
                </div>

                <div className="package-tabs-content">
                  <TabPanel>
                    <HajjPackageForm
                      key={packageId || "new"}
                      packageId={packageId}
                      isEditMode={isEditMode}
                      setIsEditMode={setIsEditMode}
                      onPackageCreated={(newId) => navigate(`/hajjpackage/${newId}`)} // <-- CORRECTED URL
                      packageDetails={packageDetails}
                    />
                  </TabPanel>
                  <TabPanel>
                    <PackageItinerary packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageFlightBooking packageId={packageId} packageDetails={packageDetails} />
                  </TabPanel>
                  <TabPanel>
                    <PackageHotelBooking packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageSightSeeing packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageTransfer packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageInclude packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageExclude packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageTermsandCondition packageId={packageId} />
                  </TabPanel>
                  <TabPanel>
                    <PackageDetailsView packageId={packageId} packageDetails={packageDetails} onEditRequest={handleTabSelect} />
                  </TabPanel>
                  <TabPanel>
                    <PackageTemplates packageId={packageId} packageDetails={packageDetails} />
                  </TabPanel>
                  <TabPanel>
                    <PackageManageApplicants packageId={packageId} />
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hajj;